import { render, staticRenderFns } from "./StoreComplaintList.vue?vue&type=template&id=85bf5438&scoped=true&"
import script from "./StoreComplaintList.vue?vue&type=script&lang=js&"
export * from "./StoreComplaintList.vue?vue&type=script&lang=js&"
import style0 from "./StoreComplaintList.vue?vue&type=style&index=0&id=85bf5438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bf5438",
  null
  
)

export default component.exports